import $ from 'jquery';
window.addEventListener('px-ready',function(){
    $('.changeto').click(function(){
        //console.log($(this).attr('data-color'));
        $('.px-axes').removeClass('is-orange-active');
        $('.px-axes').removeClass('is-blue-active');
        $('.px-axes').removeClass('is-yellow-active');
        $('.px-axes').removeClass('is-black-active');
        $('.px-axes').removeClass('is-beige-active');
        $('.px-axes').addClass('is-'+$(this).attr('data-color')+'-active');
    })
    /*console.log('arg');
    $('.spinner').click(function(e){
        console.log('hi');
        console.log($(e.target).attr('data-color'));
    })*/
})